import { BASE_URL } from '../config';
import axiosApiInstance from '../../interceptors/axiosApiInstance';

const QueuePoolService = {
    getQueuePool: async function () {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/queue-pool`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getQueuePoolDetail: async function (id) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/queue-pool/detail/${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    postQueuePool: async function (data) {
        try {
            const response = await axiosApiInstance.post(BASE_URL + `/queue-pool`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    putQueuePool: async function (id, data) {
        try {
            const response = await axiosApiInstance.put(BASE_URL + `/queue-pool/${id}`, data);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    deleteQueuePool: async function (id) {
        try {
            const response = await axiosApiInstance.delete(BASE_URL + `/queue-pool/${id}`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    }
};

export default QueuePoolService;
